import { Link, useLocation } from "react-router-dom";

const LOGO_MARK =
  "https://customer-assets.emergentagent.com/job_valuta-genio-landing/artifacts/tjenxkip_LOGO%20VALUTAPRO%20rosso%20e%20grigio.png";

export default function Logo({ light = false, size = "text-xl" }) {
  const valutaColor = light ? "text-white" : "text-[#0A0A0A]";
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  return (
    <Link
      to="/"
      onClick={handleClick}
      data-testid="logo-link"
      className={`inline-flex items-center gap-2 md:gap-2.5 font-display font-extrabold tracking-tight ${size} select-none`}
      aria-label="ValutaGenio — Torna alla home"
    >
      <img
        src={LOGO_MARK}
        alt=""
        aria-hidden="true"
        className="h-7 md:h-9 w-auto object-contain flex-shrink-0"
        loading="eager"
        decoding="async"
      />
      <span className="leading-none">
        <span className={valutaColor}>Valuta</span>
        <span className="text-[#B40101]">Genio</span>
      </span>
    </Link>
  );
}
